module.exports = __webpack_public_path__ + "img/history-tab-active.ceaa8426.svg";